
  import {
    Component,
    Model,
    Prop,
    Vue
  } from "vue-property-decorator";

  @Component({
    name: 'slz-message',
  })
  export default class extends Vue {
    @Prop({
      default: 'notice'
    }) private type!: string;
    @Prop({
      default: '内容'
    }) private content!: string;
    @Prop({
      default: '提示'
    }) private title!: string;
    @Prop({
      default: '确认'
    }) private confirmtext!: string;
    @Prop({
      default: '取消'
    }) private canceltext!: string;
    @Model('change') isShow!: boolean;
    @Prop({
      default: true
    }) private showicon!: boolean;
    @Prop({
      default: true
    }) private autoclose!: boolean;
    @Prop({
      default: true
    }) private hasconfirm!: boolean;
    @Prop({
      default: true
    }) private hascancel!: boolean;
    @Prop({
      default: '388px'
    }) private width!: string;
    @Prop({
      default: true
    }) private canclose!: boolean;

    private icons: any = {
      'notice': 'https://cdn2024.routuan.com/routuanapp/notice-icon.png',
      'warn': 'https://cdn2024.routuan.com/routuanapp/warn-icon.png',
      'success': 'https://cdn2024.routuan.com/routuanapp/success-icon.png',
      'error': 'https://cdn2024.routuan.com/routuanapp/error-icon.png'
    };

    /**
     * 关闭弹窗
     */
    private handleClose() {
      if(!this.canclose) return
      this.$emit('change', false)
    }

    private handleClick() {}

    /**
     * 确认
     */
    private confirm() {
      this.$emit('confirm')
      if(this.autoclose){
        this.handleClose();
      }
    }

    /**
     * 取消
     */
    private cancel() {
      this.$emit('cancel')
      this.handleClose();
    }
  }
